// Platform utility functions and components for consistent platform handling across the app

import { Linkedin, X, Facebook, Instagram, Youtube, Globe } from 'lucide-react'

// Custom TikTok icon component
export const TikTokIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

// Function to get the appropriate icon based on platform key
export const getPlatformIcon = (platformKey: string | null | undefined, className: string = "h-5 w-5") => {
  if (!platformKey) return null;
  
  switch(platformKey.toLowerCase()) {
    case 'linkedin':
      return <Linkedin className={className} />;
    case 'twitter':
      return <X className={className} />;
    case 'facebook':
      return <Facebook className={className} />;
    case 'instagram':
      return <Instagram className={className} />;
    case 'youtube':
      return <Youtube className={className} />;
    case 'tiktok':
      return <TikTokIcon className={className} />;
    case 'bing':
      return <Globe className={className} />;
    case 'google_ads':
      return <Globe className={className} />;
    default:
      return <Globe className={className} />;
  }
};

// Platform display names mapping
export const platformLabels: Record<string, string> = {
  'twitter': 'X/Twitter',
  'facebook': 'Facebook',
  'instagram': 'Instagram',
  'linkedin': 'LinkedIn',
  'youtube': 'YouTube',
  'tiktok': 'TikTok',
  'bing': 'Bing',
  'google_ads': 'Google Ads'
};

// Get platform display name
export const getPlatformLabel = (platformKey: string): string => {
  return platformLabels[platformKey] || platformKey;
}; 